import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from './store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useDispatchAction = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useReduxStore = <K extends keyof RootState>(key: K): RootState[K] => useAppSelector((state) => state[key]);

// export const useRecordCountStore = () => useAppSelector((state: RootState) => state.general.record_count);
